<template>
<div class="backImg">
<div class="backPurple">
  <div class="backPurple1">
    <img class="purpleBorder" src="static/img/learnMore/border.png">
    <div class="codeTxt1">网站升级中,敬请期待</div>
    <div class="codeTxt2">欢迎扫码,关注官方唯一招聘公众号</div>
    <img class="barCode" src="static/img/learnMore/barCode.png">
    <img class="jiantou" src="static/img/learnMore/jiantou.png">
  </div>
</div>
</div>
</template>

<script>
    export default {
        name: "learnMore"
    }
</script>

<style scoped>
.backImg{
  width: 100vw;
  min-height: 100vh;
  background-image: url("../../../static/img/learnMore/backImage.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
/*  align-items: center;*/
  overflow: hidden;
/* background-attachment: fixed;*/
  position: relative;

}
  .backPurple{
  /*width: 1696px;
  height: 907px;
  margin-left: 112px;*/
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    align-items: center;
    -webkit-align-items: center;
    margin: 0 auto;
    position: absolute;
    top: 8.90vw;
    bottom: 7.29vw;

  }

  .backPurple1{
    position: relative;
  }
 .purpleBorder{

   width: 87.55vw;
   height: 40.05vw;
   position: relative;

 }

.codeTxt1{
  width: 56.77vw;
  height: 6.04vw;
  top: 11.66vw;
  left: 2.29vw;
  font-size: 5.99vw;
  line-height: 8.33vw;
  font-weight: 500;
  color: #FFFFFF;
  position: absolute;

}
.codeTxt2{
  width: 65.895vw;
  height: 3.23vw;
  top: 26.05vw;
  left: 6.20vw;
  font-size: 3.125vw;
  font-weight: 600;
  position: absolute;
  color:  #FFFFFF;
  line-height: 0.52vw;



}
.jiantou{
  position: absolute;
  width: 53.906vw;
  height: 1.667vw;
  top:29.53vw;
  left: 4.375vw;
}
.barCode{
 position: absolute;
  top: 13.24vw;
  bottom: 12.03vw;
  left: 61.77vw;
  width: 18vw;
  height: 18vw;
}

</style>



// WEBPACK FOOTER //
// src/views/web/learnMore.vue